import React from "react";
import Icon from "react-icon-base";

const gdriveIcon = (props) => {
  return (
    <Icon viewBox="0 0 512 512" {...props}>
      <title>{props.title || "Gdrive"}</title>
      <g>
        <g>
          <path
            opacity="1.00"
            d=" M 167.11 35.10 L 167.55 35.09 L 167.59 35.58 L 167.03 35.60 L 167.11 35.10 Z"
          />
          <path
            opacity="1.00"
            d=" M 165.40 38.38 C 165.79 37.82 166.55 36.70 166.94 36.14 L 167.64 36.03 C 168.16 42.37 170.02 48.48 171.42 54.65 C 177.44 81.46 183.52 108.25 189.85 134.98 C 194.00 153.31 198.63 171.55 202.43 189.95 C 205.73 201.34 207.50 213.09 210.69 224.50 C 212.75 235.14 215.98 245.52 217.71 256.22 C 217.01 257.39 216.31 258.57 215.60 259.74 C 215.43 260.01 215.07 260.57 214.90 260.85 L 214.64 261.30 C 214.60 261.38 214.51 261.55 214.46 261.63 C 214.07 262.35 213.29 263.78 212.90 264.49 C 212.83 264.62 212.68 264.88 212.60 265.01 L 211.89 266.27 C 211.80 266.42 211.63 266.71 211.55 266.86 L 210.72 268.31 C 210.68 268.39 210.59 268.55 210.54 268.63 L 209.51 270.43 C 209.42 270.58 209.24 270.90 209.15 271.06 C 209.05 271.23 208.85 271.56 208.75 271.73 L 207.74 273.47 C 207.66 273.60 207.50 273.88 207.42 274.01 L 206.80 275.06 C 206.70 275.24 206.48 275.61 206.38 275.79 C 205.98 276.48 205.19 277.86 204.79 278.56 C 204.72 278.68 204.57 278.93 204.50 279.06 L 203.87 280.11 C 203.77 280.30 203.55 280.66 203.44 280.85 C 203.07 281.50 202.31 282.79 201.94 283.44 C 201.85 283.59 201.68 283.90 201.59 284.05 L 200.84 285.40 C 200.77 285.52 200.63 285.77 200.56 285.89 L 199.79 287.24 C 199.71 287.38 199.55 287.66 199.47 287.80 C 199.07 288.46 198.29 289.79 197.90 290.46 C 197.81 290.61 197.63 290.92 197.54 291.08 L 196.83 292.36 C 196.76 292.48 196.63 292.71 196.57 292.83 L 195.75 294.25 C 195.68 294.38 195.53 294.63 195.46 294.75 C 195.04 295.47 194.21 296.90 193.79 297.62 C 193.72 297.75 193.56 298.01 193.48 298.14 L 192.88 299.13 C 192.78 299.31 192.57 299.66 192.47 299.84 C 192.09 300.50 191.34 301.81 190.96 302.47 C 190.90 302.58 190.76 302.82 190.70 302.93 L 189.88 304.39 C 189.82 304.50 189.70 304.71 189.64 304.82 L 188.80 306.29 C 188.73 306.40 188.59 306.64 188.52 306.75 C 188.13 307.41 187.34 308.71 186.95 309.37 C 186.84 309.54 186.64 309.90 186.53 310.08 L 185.94 311.18 C 185.86 311.32 185.71 311.60 185.64 311.73 L 184.61 313.51 C 184.53 313.66 184.35 313.96 184.27 314.11 C 184.18 314.25 184.02 314.54 183.94 314.68 C 182.25 317.53 180.72 320.47 178.85 323.21 C 168.20 340.58 158.40 358.49 148.09 376.07 C 131.35 405.04 114.63 434.01 97.89 462.98 C 95.38 467.49 92.52 471.81 90.36 476.52 C 90.25 476.68 90.03 477.00 89.92 477.16 C 85.91 471.38 82.81 465.00 79.14 459.00 C 62.40 430.01 45.65 401.03 28.92 372.03 C 19.62 355.72 9.93 339.61 0.88 323.15 C 36.72 261.30 72.40 199.34 108.17 137.45 C 108.20 137.39 108.27 137.28 108.30 137.22 L 109.28 135.54 C 109.32 135.47 109.40 135.33 109.45 135.26 L 110.44 133.57 C 110.53 133.42 110.71 133.10 110.81 132.95 C 110.91 132.77 111.11 132.42 111.21 132.24 L 112.20 130.48 C 112.27 130.36 112.41 130.12 112.48 130.00 L 113.22 128.82 C 113.35 128.63 113.61 128.24 113.74 128.04 C 114.10 127.50 114.83 126.41 115.20 125.87 C 115.24 125.69 115.31 125.34 115.35 125.17 L 116.22 123.50 C 116.26 123.43 116.34 123.29 116.38 123.22 L 117.38 121.54 C 117.48 121.38 117.68 121.04 117.78 120.87 C 117.89 120.68 118.11 120.29 118.23 120.09 L 119.07 118.62 C 119.16 118.46 119.34 118.15 119.43 118.00 L 120.13 116.77 C 120.21 116.64 120.37 116.36 120.45 116.22 C 120.84 115.55 121.62 114.21 122.02 113.54 C 122.10 113.40 122.26 113.12 122.34 112.98 L 123.07 111.65 C 123.13 111.55 123.25 111.33 123.31 111.23 L 124.27 109.55 C 124.39 109.35 124.64 108.94 124.77 108.74 L 125.42 107.76 C 125.56 107.56 125.83 107.17 125.97 106.98 C 126.09 106.78 126.34 106.38 126.47 106.18 L 127.01 105.14 C 127.19 104.75 127.56 103.97 127.74 103.58 L 128.29 102.81 C 128.39 102.67 128.58 102.40 128.68 102.26 C 129.05 101.95 129.80 101.31 130.17 100.99 L 130.10 99.82 C 130.16 99.68 130.30 99.40 130.37 99.26 L 131.22 97.57 C 131.29 97.45 131.43 97.20 131.50 97.08 L 132.25 95.86 C 132.39 95.66 132.66 95.26 132.80 95.06 C 133.14 94.50 133.83 93.40 134.17 92.85 C 134.27 92.65 134.45 92.26 134.55 92.06 L 135.08 90.91 C 135.24 90.61 135.58 90.00 135.75 89.69 L 136.41 88.75 C 136.55 88.56 136.83 88.18 136.97 87.99 C 137.09 87.79 137.34 87.39 137.46 87.19 L 137.95 86.16 C 138.06 85.93 138.29 85.46 138.40 85.23 L 139.26 83.57 C 139.39 83.37 139.64 82.95 139.76 82.74 L 140.42 81.76 C 140.56 81.56 140.84 81.18 140.98 80.98 C 141.11 80.78 141.36 80.37 141.48 80.17 L 141.99 79.13 C 142.14 78.84 142.43 78.27 142.57 77.98 L 143.25 76.86 C 143.37 76.67 143.61 76.29 143.74 76.10 C 144.10 75.54 144.83 74.42 145.20 73.87 C 145.24 73.70 145.33 73.36 145.37 73.19 L 146.24 71.53 C 146.27 71.46 146.35 71.33 146.39 71.26 L 147.39 69.55 C 147.49 69.38 147.68 69.05 147.78 68.88 C 147.88 68.72 148.07 68.38 148.17 68.22 L 149.17 66.47 C 149.21 66.40 149.29 66.26 149.33 66.18 L 150.27 64.55 C 150.32 64.48 150.41 64.33 150.45 64.25 L 151.46 62.55 C 151.55 62.39 151.73 62.09 151.82 61.93 C 151.92 61.76 152.12 61.41 152.22 61.23 L 153.18 59.54 C 153.24 59.43 153.36 59.22 153.42 59.12 L 154.23 57.81 C 154.36 57.62 154.62 57.23 154.74 57.04 C 155.11 56.49 155.83 55.39 156.20 54.84 C 156.23 54.67 156.31 54.33 156.35 54.16 L 157.20 52.53 C 157.27 52.41 157.42 52.16 157.49 52.03 L 158.25 50.84 C 158.39 50.65 158.65 50.26 158.79 50.06 C 159.14 49.50 159.84 48.39 160.19 47.83 C 160.24 47.67 160.33 47.35 160.38 47.19 L 161.26 45.54 C 161.30 45.46 161.38 45.32 161.42 45.24 L 162.44 43.52 C 162.52 43.37 162.70 43.07 162.79 42.92 C 162.88 42.75 163.06 42.43 163.15 42.27 L 164.15 40.49 C 164.20 40.42 164.28 40.27 164.32 40.20 L 165.27 38.59 C 165.30 38.54 165.37 38.43 165.40 38.38 Z"
          />
        </g>
        <g>
          <path
            opacity="1.00"
            d=" M 167.55 35.09 C 200.03 34.94 232.52 35.07 265.01 35.02 C 291.89 35.12 318.79 34.81 345.66 35.17 C 346.19 36.19 346.73 37.20 347.30 38.21 C 347.38 38.34 347.53 38.62 347.61 38.76 C 350.21 43.29 352.85 47.80 355.42 52.34 C 355.47 52.42 355.55 52.57 355.60 52.64 C 360.58 61.19 365.54 69.75 370.43 78.35 C 370.47 78.42 370.56 78.56 370.60 78.64 C 371.49 80.17 372.41 81.70 373.32 83.24 C 373.40 83.37 373.55 83.64 373.63 83.78 C 374.88 85.98 376.14 88.17 377.41 90.36 C 377.46 90.43 377.54 90.57 377.58 90.65 C 378.85 92.83 380.10 95.03 381.36 97.23 C 381.44 97.36 381.59 97.62 381.67 97.75 C 382.94 99.89 384.17 102.05 385.39 104.21 C 385.47 104.34 385.62 104.61 385.70 104.74 C 397.64 125.36 409.55 145.99 421.45 166.64 C 420.09 172.63 423.38 178.59 421.55 184.61 C 420.44 201.06 414.23 217.07 403.99 229.99 C 400.66 233.60 403.89 238.61 403.53 242.89 C 399.94 247.24 395.32 250.49 390.96 254.00 C 390.97 257.28 390.98 260.56 390.83 263.85 C 386.94 266.42 382.48 267.91 378.53 270.39 C 378.11 271.72 377.68 273.06 377.27 274.41 C 374.10 275.91 370.71 276.88 367.54 278.40 C 354.99 274.80 342.57 270.79 330.05 267.08 C 318.40 263.23 306.47 260.21 294.94 255.97 L 294.28 254.79 C 294.22 254.70 294.12 254.52 294.07 254.43 L 293.12 252.82 C 293.02 252.65 292.82 252.31 292.72 252.14 C 292.63 251.99 292.47 251.70 292.38 251.55 C 291.67 250.29 291.02 249.00 290.44 247.68 L 290.38 247.55 L 290.31 247.45 C 289.87 246.75 288.98 245.34 288.53 244.64 C 288.48 244.56 288.38 244.40 288.33 244.31 L 288.04 243.85 C 287.87 243.56 287.52 242.99 287.35 242.70 C 286.92 241.97 286.05 240.51 285.62 239.78 C 285.51 239.60 285.30 239.23 285.19 239.05 L 284.58 238.01 C 284.50 237.87 284.34 237.60 284.26 237.46 L 283.29 235.79 C 283.25 235.72 283.16 235.58 283.12 235.50 L 282.10 233.75 C 282.01 233.59 281.83 233.27 281.74 233.12 C 281.64 232.94 281.43 232.57 281.33 232.39 L 280.50 230.93 C 280.40 230.76 280.20 230.40 280.10 230.23 L 279.46 229.10 C 279.37 228.95 279.20 228.65 279.11 228.50 C 278.72 227.78 277.93 226.35 277.53 225.63 C 277.49 225.55 277.39 225.38 277.35 225.30 L 277.08 224.83 C 276.89 224.55 276.52 223.99 276.33 223.71 C 275.34 222.05 274.41 220.35 273.52 218.64 C 273.47 218.56 273.38 218.39 273.34 218.31 L 273.08 217.85 C 272.89 217.58 272.51 217.04 272.32 216.78 C 271.88 215.99 271.00 214.41 270.56 213.62 C 270.51 213.54 270.41 213.37 270.37 213.28 L 270.10 212.80 C 269.90 212.47 269.51 211.82 269.31 211.49 L 268.45 210.04 C 268.37 209.90 268.20 209.62 268.11 209.47 C 267.73 208.81 266.96 207.48 266.57 206.82 C 266.48 206.67 266.31 206.36 266.22 206.20 C 265.54 205.07 264.89 203.93 264.25 202.79 C 264.20 202.70 264.09 202.52 264.04 202.43 L 263.09 200.80 C 262.99 200.64 262.80 200.32 262.71 200.15 C 262.62 200.00 262.45 199.70 262.36 199.55 L 261.35 197.79 C 261.30 197.71 261.21 197.54 261.16 197.46 L 260.34 195.99 C 260.27 195.87 260.14 195.64 260.07 195.52 C 259.69 194.85 258.92 193.52 258.54 192.85 C 258.46 192.71 258.30 192.44 258.22 192.31 C 257.60 191.28 256.98 190.24 256.38 189.21 C 228.65 141.09 200.88 93.00 173.09 44.91 C 171.35 41.91 169.77 38.79 167.64 36.03 L 167.59 35.58 L 167.55 35.09 Z"
          />
        </g>
        <g>
          <path
            opacity="1.00"
            d=" M 167.03 35.60 L 167.59 35.58 L 167.64 36.03 L 166.94 36.14 L 167.03 35.60 Z"
          />
          <path
            opacity="1.00"
            d=" M 167.64 36.03 C 169.77 38.79 171.35 41.91 173.09 44.91 C 200.88 93.00 228.65 141.09 256.38 189.21 C 243.54 211.57 230.60 233.88 217.71 256.22 C 215.98 245.52 212.75 235.14 210.69 224.50 C 207.50 213.09 205.73 201.34 202.43 189.95 C 198.63 171.55 194.00 153.31 189.85 134.98 C 183.52 108.25 177.44 81.46 171.42 54.65 C 170.02 48.48 168.16 42.37 167.64 36.03 Z"
          />
          <path
            opacity="1.00"
            d=" M 165.27 38.59 C 165.30 38.54 165.37 38.43 165.40 38.38 C 165.37 38.43 165.30 38.54 165.27 38.59 Z"
          />
          <path
            opacity="1.00"
            d=" M 164.15 40.49 C 164.20 40.42 164.28 40.27 164.32 40.20 C 164.28 40.27 164.20 40.42 164.15 40.49 Z"
          />
          <path
            opacity="1.00"
            d=" M 162.79 42.92 C 162.88 42.75 163.06 42.43 163.15 42.27 C 163.06 42.43 162.88 42.75 162.79 42.92 Z"
          />
          <path
            opacity="1.00"
            d=" M 162.44 43.52 C 162.52 43.37 162.70 43.07 162.79 42.92 C 162.70 43.07 162.52 43.37 162.44 43.52 Z"
          />
          <path
            opacity="1.00"
            d=" M 161.26 45.54 C 161.30 45.46 161.38 45.32 161.42 45.24 C 161.38 45.32 161.30 45.46 161.26 45.54 Z"
          />
          <path
            opacity="1.00"
            d=" M 160.19 47.83 C 160.24 47.67 160.33 47.35 160.38 47.19 C 160.33 47.35 160.24 47.67 160.19 47.83 Z"
          />
          <path
            opacity="1.00"
            d=" M 158.79 50.06 C 159.14 49.50 159.84 48.39 160.19 47.83 C 159.84 48.39 159.14 49.50 158.79 50.06 Z"
          />
          <path
            opacity="1.00"
            d=" M 158.25 50.84 C 158.39 50.65 158.65 50.26 158.79 50.06 C 158.65 50.26 158.39 50.65 158.25 50.84 Z"
          />
          <path
            opacity="1.00"
            d=" M 157.20 52.53 C 157.27 52.41 157.42 52.16 157.49 52.03 C 157.42 52.16 157.27 52.41 157.20 52.53 Z"
          />
          <path
            opacity="1.00"
            d=" M 156.20 54.84 C 156.23 54.67 156.31 54.33 156.35 54.16 C 156.31 54.33 156.23 54.67 156.20 54.84 Z"
          />
          <path
            opacity="1.00"
            d=" M 154.74 57.04 C 155.11 56.49 155.83 55.39 156.20 54.84 C 155.83 55.39 155.11 56.49 154.74 57.04 Z"
          />
          <path
            opacity="1.00"
            d=" M 154.23 57.81 C 154.36 57.62 154.62 57.23 154.74 57.04 C 154.62 57.23 154.36 57.62 154.23 57.81 Z"
          />
          <path
            opacity="1.00"
            d=" M 153.18 59.54 C 153.24 59.43 153.36 59.22 153.42 59.12 C 153.36 59.22 153.24 59.43 153.18 59.54 Z"
          />
          <path
            opacity="1.00"
            d=" M 151.82 61.93 C 151.92 61.76 152.12 61.41 152.22 61.23 C 152.12 61.41 151.92 61.76 151.82 61.93 Z"
          />
          <path
            opacity="1.00"
            d=" M 151.46 62.55 C 151.55 62.39 151.73 62.09 151.82 61.93 C 151.73 62.09 151.55 62.39 151.46 62.55 Z"
          />
          <path
            opacity="1.00"
            d=" M 150.27 64.55 C 150.32 64.48 150.41 64.33 150.45 64.25 C 150.41 64.33 150.32 64.48 150.27 64.55 Z"
          />
          <path
            opacity="1.00"
            d=" M 149.17 66.47 C 149.21 66.40 149.29 66.26 149.33 66.18 C 149.29 66.26 149.21 66.40 149.17 66.47 Z"
          />
          <path
            opacity="1.00"
            d=" M 147.78 68.88 C 147.88 68.72 148.07 68.38 148.17 68.22 C 148.07 68.38 147.88 68.72 147.78 68.88 Z"
          />
          <path
            opacity="1.00"
            d=" M 147.39 69.55 C 147.49 69.38 147.68 69.05 147.78 68.88 C 147.68 69.05 147.49 69.38 147.39 69.55 Z"
          />
          <path
            opacity="1.00"
            d=" M 146.24 71.53 C 146.27 71.46 146.35 71.33 146.39 71.26 C 146.35 71.33 146.27 71.46 146.24 71.53 Z"
          />
          <path
            opacity="1.00"
            d=" M 145.20 73.87 C 145.24 73.70 145.33 73.36 145.37 73.19 C 145.33 73.36 145.24 73.70 145.20 73.87 Z"
          />
          <path
            opacity="1.00"
            d=" M 143.74 76.10 C 144.10 75.54 144.83 74.42 145.20 73.87 C 144.83 74.42 144.10 75.54 143.74 76.10 Z"
          />
          <path
            opacity="1.00"
            d=" M 143.25 76.86 C 143.37 76.67 143.61 76.29 143.74 76.10 C 143.61 76.29 143.37 76.67 143.25 76.86 Z"
          />
          <path
            opacity="1.00"
            d=" M 141.99 79.13 C 142.14 78.84 142.43 78.27 142.57 77.98 C 142.43 78.27 142.14 78.84 141.99 79.13 Z"
          />
          <path
            opacity="1.00"
            d=" M 140.98 80.98 C 141.11 80.78 141.36 80.37 141.48 80.17 C 141.36 80.37 141.11 80.78 140.98 80.98 Z"
          />
          <path
            opacity="1.00"
            d=" M 140.42 81.76 C 140.56 81.56 140.84 81.18 140.98 80.98 C 140.84 81.18 140.56 81.56 140.42 81.76 Z"
          />
          <path
            opacity="1.00"
            d=" M 139.26 83.57 C 139.39 83.37 139.64 82.95 139.76 82.74 C 139.64 82.95 139.39 83.37 139.26 83.57 Z"
          />
          <path
            opacity="1.00"
            d=" M 137.95 86.16 C 138.06 85.93 138.29 85.46 138.40 85.23 C 138.29 85.46 138.06 85.93 137.95 86.16 Z"
          />
          <path
            opacity="1.00"
            d=" M 136.97 87.99 C 137.09 87.79 137.34 87.39 137.46 87.19 C 137.34 87.39 137.09 87.79 136.97 87.99 Z"
          />
          <path
            opacity="1.00"
            d=" M 136.41 88.75 C 136.55 88.56 136.83 88.18 136.97 87.99 C 136.83 88.18 136.55 88.56 136.41 88.75 Z"
          />
          <path
            opacity="1.00"
            d=" M 135.08 90.91 C 135.24 90.61 135.58 90.00 135.75 89.69 C 135.58 90.00 135.24 90.61 135.08 90.91 Z"
          />
          <path
            opacity="1.00"
            d=" M 134.17 92.85 C 134.27 92.65 134.45 92.26 134.55 92.06 C 134.45 92.26 134.27 92.65 134.17 92.85 Z"
          />
          <path
            opacity="1.00"
            d=" M 132.80 95.06 C 133.14 94.50 133.83 93.40 134.17 92.85 C 133.83 93.40 133.14 94.50 132.80 95.06 Z"
          />
          <path
            opacity="1.00"
            d=" M 132.25 95.86 C 132.39 95.66 132.66 95.26 132.80 95.06 C 132.66 95.26 132.39 95.66 132.25 95.86 Z"
          />
          <path
            opacity="1.00"
            d=" M 131.22 97.57 C 131.29 97.45 131.43 97.20 131.50 97.08 C 131.43 97.20 131.29 97.45 131.22 97.57 Z"
          />
          <path
            opacity="1.00"
            d=" M 130.10 99.82 C 130.16 99.68 130.30 99.40 130.37 99.26 C 130.30 99.40 130.16 99.68 130.10 99.82 Z"
          />
          <path
            opacity="1.00"
            d=" M 128.68 102.26 C 129.03 101.65 129.74 100.43 130.10 99.82 L 130.17 100.99 C 129.80 101.31 129.05 101.95 128.68 102.26 Z"
          />
          <path
            opacity="1.00"
            d=" M 128.29 102.81 C 128.39 102.67 128.58 102.40 128.68 102.26 C 128.58 102.40 128.39 102.67 128.29 102.81 Z"
          />
          <path
            opacity="1.00"
            d=" M 127.01 105.14 C 127.19 104.75 127.56 103.97 127.74 103.58 C 127.56 103.97 127.19 104.75 127.01 105.14 Z"
          />
          <path
            opacity="1.00"
            d=" M 125.97 106.98 C 126.09 106.78 126.34 106.38 126.47 106.18 C 126.34 106.38 126.09 106.78 125.97 106.98 Z"
          />
          <path
            opacity="1.00"
            d=" M 125.42 107.76 C 125.56 107.56 125.83 107.17 125.97 106.98 C 125.83 107.17 125.56 107.56 125.42 107.76 Z"
          />
          <path
            opacity="1.00"
            d=" M 124.27 109.55 C 124.39 109.35 124.64 108.94 124.77 108.74 C 124.64 108.94 124.39 109.35 124.27 109.55 Z"
          />
          <path
            opacity="1.00"
            d=" M 123.07 111.65 C 123.13 111.55 123.25 111.33 123.31 111.23 C 123.25 111.33 123.13 111.55 123.07 111.65 Z"
          />
          <path
            opacity="1.00"
            d=" M 122.02 113.54 C 122.10 113.40 122.26 113.12 122.34 112.98 C 122.26 113.12 122.10 113.40 122.02 113.54 Z"
          />
          <path
            opacity="1.00"
            d=" M 120.13 116.77 C 120.21 116.64 120.37 116.36 120.45 116.22 C 120.37 116.36 120.21 116.64 120.13 116.77 Z"
          />
          <path
            opacity="1.00"
            d=" M 119.07 118.62 C 119.16 118.46 119.34 118.15 119.43 118.00 C 119.34 118.15 119.16 118.46 119.07 118.62 Z"
          />
          <path
            opacity="1.00"
            d=" M 117.78 120.87 C 117.89 120.68 118.11 120.29 118.23 120.09 C 118.11 120.29 117.89 120.68 117.78 120.87 Z"
          />
          <path
            opacity="1.00"
            d=" M 117.38 121.54 C 117.48 121.38 117.68 121.04 117.78 120.87 C 117.68 121.04 117.48 121.38 117.38 121.54 Z"
          />
          <path
            opacity="1.00"
            d=" M 116.22 123.50 C 116.26 123.43 116.34 123.29 116.38 123.22 C 116.34 123.29 116.26 123.43 116.22 123.50 Z"
          />
          <path
            opacity="1.00"
            d=" M 115.20 125.87 C 115.24 125.69 115.31 125.34 115.35 125.17 C 115.31 125.34 115.24 125.69 115.20 125.87 Z"
          />
          <path
            opacity="1.00"
            d=" M 113.74 128.04 C 114.10 127.50 114.83 126.41 115.20 125.87 C 114.83 126.41 114.10 127.50 113.74 128.04 Z"
          />
          <path
            opacity="1.00"
            d=" M 113.22 128.82 C 113.35 128.63 113.61 128.24 113.74 128.04 C 113.61 128.24 113.35 128.63 113.22 128.82 Z"
          />
          <path
            opacity="1.00"
            d=" M 112.20 130.48 C 112.27 130.36 112.41 130.12 112.48 130.00 C 112.41 130.12 112.27 130.36 112.20 130.48 Z"
          />
          <path
            opacity="1.00"
            d=" M 110.81 132.95 C 110.91 132.77 111.11 132.42 111.21 132.24 C 111.11 132.42 110.91 132.77 110.81 132.95 Z"
          />
          <path
            opacity="1.00"
            d=" M 110.44 133.57 C 110.53 133.42 110.71 133.10 110.81 132.95 C 110.71 133.10 110.53 133.42 110.44 133.57 Z"
          />
          <path
            opacity="1.00"
            d=" M 109.28 135.54 C 109.32 135.47 109.40 135.33 109.45 135.26 C 109.40 135.33 109.32 135.47 109.28 135.54 Z"
          />
          <path
            opacity="1.00"
            d=" M 108.17 137.45 C 108.20 137.39 108.27 137.28 108.30 137.22 C 108.27 137.28 108.20 137.39 108.17 137.45 Z"
          />
          <path
            opacity="1.00"
            d=" M 214.90 260.85 C 215.07 260.57 215.43 260.01 215.60 259.74 C 215.43 260.01 215.07 260.57 214.90 260.85 Z"
          />
          <path
            opacity="1.00"
            d=" M 214.46 261.63 C 214.51 261.55 214.60 261.38 214.64 261.30 C 214.60 261.38 214.51 261.55 214.46 261.63 Z"
          />
          <path
            opacity="1.00"
            d=" M 212.60 265.01 C 212.68 264.88 212.83 264.62 212.90 264.49 C 212.83 264.62 212.68 264.88 212.60 265.01 Z"
          />
          <path
            opacity="1.00"
            d=" M 211.55 266.86 C 211.63 266.71 211.80 266.42 211.89 266.27 C 211.80 266.42 211.63 266.71 211.55 266.86 Z"
          />
          <path
            opacity="1.00"
            d=" M 210.54 268.63 C 210.59 268.55 210.68 268.39 210.72 268.31 C 210.68 268.39 210.59 268.55 210.54 268.63 Z"
          />
          <path
            opacity="1.00"
            d=" M 209.15 271.06 C 209.24 270.90 209.42 270.58 209.51 270.43 C 209.42 270.58 209.24 270.90 209.15 271.06 Z"
          />
          <path
            opacity="1.00"
            d=" M 208.75 271.73 C 208.85 271.56 209.05 271.23 209.15 271.06 C 209.05 271.23 208.85 271.56 208.75 271.73 Z"
          />
          <path
            opacity="1.00"
            d=" M 207.42 274.01 C 207.50 273.88 207.66 273.60 207.74 273.47 C 207.66 273.60 207.50 273.88 207.42 274.01 Z"
          />
          <path
            opacity="1.00"
            d=" M 206.38 275.79 C 206.48 275.61 206.70 275.24 206.80 275.06 C 206.70 275.24 206.48 275.61 206.38 275.79 Z"
          />
          <path
            opacity="1.00"
            d=" M 204.50 279.06 C 204.57 278.93 204.72 278.68 204.79 278.56 C 204.72 278.68 204.57 278.93 204.50 279.06 Z"
          />
          <path
            opacity="1.00"
            d=" M 203.44 280.85 C 203.55 280.66 203.77 280.30 203.87 280.11 C 203.77 280.30 203.55 280.66 203.44 280.85 Z"
          />
          <path
            opacity="1.00"
            d=" M 201.59 284.05 C 201.68 283.90 201.85 283.59 201.94 283.44 C 201.85 283.59 201.68 283.90 201.59 284.05 Z"
          />
          <path
            opacity="1.00"
            d=" M 200.56 285.89 C 200.63 285.77 200.77 285.52 200.84 285.40 C 200.77 285.52 200.63 285.77 200.56 285.89 Z"
          />
          <path
            opacity="1.00"
            d=" M 199.47 287.80 C 199.55 287.66 199.71 287.38 199.79 287.24 C 199.71 287.38 199.55 287.66 199.47 287.80 Z"
          />
          <path
            opacity="1.00"
            d=" M 197.54 291.08 C 197.63 290.92 197.81 290.61 197.90 290.46 C 197.81 290.61 197.63 290.92 197.54 291.08 Z"
          />
          <path
            opacity="1.00"
            d=" M 196.57 292.83 C 196.63 292.71 196.76 292.48 196.83 292.36 C 196.76 292.48 196.63 292.71 196.57 292.83 Z"
          />
          <path
            opacity="1.00"
            d=" M 195.46 294.75 C 195.53 294.63 195.68 294.38 195.75 294.25 C 195.68 294.38 195.53 294.63 195.46 294.75 Z"
          />
          <path
            opacity="1.00"
            d=" M 193.48 298.14 C 193.56 298.01 193.72 297.75 193.79 297.62 C 193.72 297.75 193.56 298.01 193.48 298.14 Z"
          />
          <path
            opacity="1.00"
            d=" M 192.47 299.84 C 192.57 299.66 192.78 299.31 192.88 299.13 C 192.78 299.31 192.57 299.66 192.47 299.84 Z"
          />
          <path
            opacity="1.00"
            d=" M 190.70 302.93 C 190.76 302.82 190.90 302.58 190.96 302.47 C 190.90 302.58 190.76 302.82 190.70 302.93 Z"
          />
          <path
            opacity="1.00"
            d=" M 189.64 304.82 C 189.70 304.71 189.82 304.50 189.88 304.39 C 189.82 304.50 189.70 304.71 189.64 304.82 Z"
          />
          <path
            opacity="1.00"
            d=" M 188.52 306.75 C 188.59 306.64 188.73 306.40 188.80 306.29 C 188.73 306.40 188.59 306.64 188.52 306.75 Z"
          />
          <path
            opacity="1.00"
            d=" M 186.53 310.08 C 186.64 309.90 186.84 309.54 186.95 309.37 C 186.84 309.54 186.64 309.90 186.53 310.08 Z"
          />
          <path
            opacity="1.00"
            d=" M 185.64 311.73 C 185.71 311.60 185.86 311.32 185.94 311.18 C 185.86 311.32 185.71 311.60 185.64 311.73 Z"
          />
          <path
            opacity="1.00"
            d=" M 184.27 314.11 C 184.35 313.96 184.53 313.66 184.61 313.51 C 184.53 313.66 184.35 313.96 184.27 314.11 Z"
          />
          <path
            opacity="1.00"
            d=" M 183.94 314.68 C 184.02 314.54 184.18 314.25 184.27 314.11 C 184.18 314.25 184.02 314.54 183.94 314.68 Z"
          />
        </g>
        <g>
          <path
            opacity="1.00"
            d=" M 347.30 38.21 C 347.38 38.34 347.53 38.62 347.61 38.76 C 347.53 38.62 347.38 38.34 347.30 38.21 Z"
          />
          <path
            opacity="1.00"
            d=" M 355.42 52.34 C 355.47 52.42 355.55 52.57 355.60 52.64 C 355.55 52.57 355.47 52.42 355.42 52.34 Z"
          />
          <path
            opacity="1.00"
            d=" M 370.43 78.35 C 370.47 78.42 370.56 78.56 370.60 78.64 C 370.56 78.56 370.47 78.42 370.43 78.35 Z"
          />
          <path
            opacity="1.00"
            d=" M 373.32 83.24 C 373.40 83.37 373.55 83.64 373.63 83.78 C 373.55 83.64 373.40 83.37 373.32 83.24 Z"
          />
          <path
            opacity="1.00"
            d=" M 377.41 90.36 C 377.46 90.43 377.54 90.57 377.58 90.65 C 377.54 90.57 377.46 90.43 377.41 90.36 Z"
          />
          <path
            opacity="1.00"
            d=" M 381.36 97.23 C 381.44 97.36 381.59 97.62 381.67 97.75 C 381.59 97.62 381.44 97.36 381.36 97.23 Z"
          />
          <path
            opacity="1.00"
            d=" M 385.39 104.21 C 385.47 104.34 385.62 104.61 385.70 104.74 C 385.62 104.61 385.47 104.34 385.39 104.21 Z"
          />
        </g>
        <g>
          <path
            opacity="1.00"
            d=" M 421.45 166.64 C 438.84 196.77 456.34 226.85 473.59 257.07 C 473.67 257.20 473.83 257.48 473.91 257.61 C 474.31 258.27 475.11 259.58 475.50 260.23 C 475.58 260.36 475.74 260.63 475.82 260.76 L 476.62 262.13 C 476.67 262.22 476.77 262.41 476.83 262.50 L 477.83 264.24 C 477.93 264.41 478.12 264.76 478.22 264.93 C 478.31 265.08 478.49 265.39 478.58 265.55 L 479.56 267.25 C 479.60 267.32 479.68 267.46 479.72 267.53 L 480.70 269.21 C 480.74 269.28 480.82 269.41 480.86 269.48 L 481.84 271.18 C 481.94 271.35 482.13 271.68 482.23 271.85 C 482.32 272.02 482.51 272.35 482.60 272.51 L 483.61 274.29 C 483.75 274.64 484.03 275.32 484.17 275.66 L 484.45 276.21 L 484.58 276.50 L 484.80 276.79 L 485.39 277.68 C 485.60 278.01 486.01 278.67 486.22 279.00 C 486.34 279.20 486.60 279.60 486.72 279.80 L 487.38 280.85 C 487.58 281.30 487.98 282.21 488.18 282.66 L 488.48 283.20 L 488.59 283.41 L 488.68 283.54 C 489.12 284.19 489.99 285.50 490.43 286.15 C 490.54 286.33 490.76 286.69 490.88 286.87 L 491.48 287.87 C 491.57 288.03 491.75 288.34 491.84 288.49 L 492.85 290.26 C 492.94 290.42 493.12 290.74 493.21 290.90 C 493.30 291.06 493.48 291.37 493.57 291.53 L 494.57 293.24 C 494.61 293.32 494.70 293.47 494.75 293.54 L 495.66 295.14 C 495.72 295.24 495.84 295.45 495.90 295.55 L 496.82 297.16 C 496.93 297.34 497.14 297.71 497.25 297.89 C 497.34 298.05 497.53 298.37 497.62 298.53 C 498.36 299.76 499.07 301.01 499.73 302.29 C 499.83 302.50 500.03 302.92 500.12 303.13 L 500.58 304.17 C 500.70 304.37 500.94 304.78 501.05 304.98 C 501.20 305.18 501.49 305.56 501.64 305.75 L 502.33 306.73 C 502.45 306.92 502.69 307.30 502.82 307.50 L 503.83 309.25 C 503.92 309.41 504.10 309.73 504.19 309.89 C 504.28 310.05 504.46 310.36 504.56 310.52 L 505.56 312.24 C 505.60 312.32 505.68 312.46 505.72 312.53 L 506.67 314.19 C 506.71 314.26 506.79 314.39 506.83 314.46 L 507.80 316.15 C 507.90 316.32 508.10 316.66 508.20 316.84 C 508.30 317.01 508.50 317.35 508.59 317.52 L 509.59 319.24 C 509.63 319.31 509.70 319.45 509.74 319.52 L 510.80 321.50 L 510.79 322.40 C 485.77 315.21 461.15 306.68 436.06 299.75 C 413.29 292.40 390.31 285.71 367.54 278.40 C 370.71 276.88 374.10 275.91 377.27 274.41 C 377.68 273.06 378.11 271.72 378.53 270.39 C 382.48 267.91 386.94 266.42 390.83 263.85 C 390.98 260.56 390.97 257.28 390.96 254.00 C 395.32 250.49 399.94 247.24 403.53 242.89 C 403.89 238.61 400.66 233.60 403.99 229.99 C 414.23 217.07 420.44 201.06 421.55 184.61 C 423.38 178.59 420.09 172.63 421.45 166.64 Z"
          />
          <path
            opacity="1.00"
            d=" M 510.79 322.40 L 511.31 322.42 L 511.60 323.18 L 511.01 323.22 L 510.79 322.40 Z"
          />
        </g>
        <g>
          <path
            opacity="1.00"
            d=" M 258.22 192.31 C 258.30 192.44 258.46 192.71 258.54 192.85 C 258.46 192.71 258.30 192.44 258.22 192.31 Z"
          />
          <path
            opacity="1.00"
            d=" M 260.07 195.52 C 260.14 195.64 260.27 195.87 260.34 195.99 C 260.27 195.87 260.14 195.64 260.07 195.52 Z"
          />
          <path
            opacity="1.00"
            d=" M 261.16 197.46 C 261.21 197.54 261.30 197.71 261.35 197.79 C 261.30 197.71 261.21 197.54 261.16 197.46 Z"
          />
          <path
            opacity="1.00"
            d=" M 262.36 199.55 C 262.45 199.70 262.62 200.00 262.71 200.15 C 262.62 200.00 262.45 199.70 262.36 199.55 Z"
          />
          <path
            opacity="1.00"
            d=" M 262.71 200.15 C 262.80 200.32 262.99 200.64 263.09 200.80 C 262.99 200.64 262.80 200.32 262.71 200.15 Z"
          />
          <path
            opacity="1.00"
            d=" M 264.04 202.43 C 264.09 202.52 264.20 202.70 264.25 202.79 C 264.20 202.70 264.09 202.52 264.04 202.43 Z"
          />
          <path
            opacity="1.00"
            d=" M 266.22 206.20 C 266.31 206.36 266.48 206.67 266.57 206.82 C 266.48 206.67 266.31 206.36 266.22 206.20 Z"
          />
          <path
            opacity="1.00"
            d=" M 268.11 209.47 C 268.20 209.62 268.37 209.90 268.45 210.04 C 268.37 209.90 268.20 209.62 268.11 209.47 Z"
          />
          <path
            opacity="1.00"
            d=" M 269.31 211.49 C 269.51 211.82 269.90 212.47 270.10 212.80 C 269.90 212.47 269.51 211.82 269.31 211.49 Z"
          />
          <path
            opacity="1.00"
            d=" M 270.37 213.28 C 270.41 213.37 270.51 213.54 270.56 213.62 C 270.51 213.54 270.41 213.37 270.37 213.28 Z"
          />
          <path
            opacity="1.00"
            d=" M 272.32 216.78 C 272.51 217.04 272.89 217.58 273.08 217.85 C 272.89 217.58 272.51 217.04 272.32 216.78 Z"
          />
          <path
            opacity="1.00"
            d=" M 273.34 218.31 C 273.38 218.39 273.47 218.56 273.52 218.64 C 273.47 218.56 273.38 218.39 273.34 218.31 Z"
          />
          <path
            opacity="1.00"
            d=" M 276.33 223.71 C 276.52 223.99 276.89 224.55 277.08 224.83 C 276.89 224.55 276.52 223.99 276.33 223.71 Z"
          />
          <path
            opacity="1.00"
            d=" M 277.35 225.30 C 277.39 225.38 277.49 225.55 277.53 225.63 C 277.49 225.55 277.39 225.38 277.35 225.30 Z"
          />
          <path
            opacity="1.00"
            d=" M 279.11 228.50 C 279.20 228.65 279.37 228.95 279.46 229.10 C 279.37 228.95 279.20 228.65 279.11 228.50 Z"
          />
          <path
            opacity="1.00"
            d=" M 280.10 230.23 C 280.20 230.40 280.40 230.76 280.50 230.93 C 280.40 230.76 280.20 230.40 280.10 230.23 Z"
          />
          <path
            opacity="1.00"
            d=" M 281.33 232.39 C 281.43 232.57 281.64 232.94 281.74 233.12 C 281.64 232.94 281.43 232.57 281.33 232.39 Z"
          />
          <path
            opacity="1.00"
            d=" M 281.74 233.12 C 281.83 233.27 282.01 233.59 282.10 233.75 C 282.01 233.59 281.83 233.27 281.74 233.12 Z"
          />
          <path
            opacity="1.00"
            d=" M 283.12 235.50 C 283.16 235.58 283.25 235.72 283.29 235.79 C 283.25 235.72 283.16 235.58 283.12 235.50 Z"
          />
          <path
            opacity="1.00"
            d=" M 284.26 237.46 C 284.34 237.60 284.50 237.87 284.58 238.01 C 284.50 237.87 284.34 237.60 284.26 237.46 Z"
          />
          <path
            opacity="1.00"
            d=" M 285.19 239.05 C 285.30 239.23 285.51 239.60 285.62 239.78 C 285.51 239.60 285.30 239.23 285.19 239.05 Z"
          />
          <path
            opacity="1.00"
            d=" M 287.35 242.70 C 287.52 242.99 287.87 243.56 288.04 243.85 C 287.87 243.56 287.52 242.99 287.35 242.70 Z"
          />
          <path
            opacity="1.00"
            d=" M 288.33 244.31 C 288.38 244.40 288.48 244.56 288.53 244.64 C 288.48 244.56 288.38 244.40 288.33 244.31 Z"
          />
          <path
            opacity="1.00"
            d=" M 290.31 247.45 L 290.38 247.55 L 290.44 247.68 C 290.41 247.62 290.34 247.51 290.31 247.45 Z"
          />
          <path
            opacity="1.00"
            d=" M 292.38 251.55 C 292.47 251.70 292.63 251.99 292.72 252.14 C 292.63 251.99 292.47 251.70 292.38 251.55 Z"
          />
          <path
            opacity="1.00"
            d=" M 292.72 252.14 C 292.82 252.31 293.02 252.65 293.12 252.82 C 293.02 252.65 292.82 252.31 292.72 252.14 Z"
          />
          <path
            opacity="1.00"
            d=" M 294.07 254.43 C 294.12 254.52 294.22 254.70 294.28 254.79 C 294.22 254.70 294.12 254.52 294.07 254.43 Z"
          />
          <path
            opacity="1.00"
            d=" M 294.94 255.97 C 306.47 260.21 318.40 263.23 330.05 267.08 C 342.57 270.79 354.99 274.80 367.54 278.40 C 390.31 285.71 413.29 292.40 436.06 299.75 C 435.72 304.62 436.68 309.61 435.47 314.39 C 434.54 319.04 428.98 319.77 426.69 323.48 C 395.92 323.49 365.16 323.58 334.40 323.45 L 333.74 323.40 C 321.03 300.80 307.81 278.48 294.94 255.97 Z"
          />
        </g>
        <g>
          <path
            opacity="1.00"
            d=" M 473.59 257.07 C 473.67 257.20 473.83 257.48 473.91 257.61 C 473.83 257.48 473.67 257.20 473.59 257.07 Z"
          />
          <path
            opacity="1.00"
            d=" M 475.50 260.23 C 475.58 260.36 475.74 260.63 475.82 260.76 C 475.74 260.63 475.58 260.36 475.50 260.23 Z"
          />
          <path
            opacity="1.00"
            d=" M 476.62 262.13 C 476.67 262.22 476.77 262.41 476.83 262.50 C 476.77 262.41 476.67 262.22 476.62 262.13 Z"
          />
          <path
            opacity="1.00"
            d=" M 477.83 264.24 C 477.93 264.41 478.12 264.76 478.22 264.93 C 478.12 264.76 477.93 264.41 477.83 264.24 Z"
          />
          <path
            opacity="1.00"
            d=" M 478.22 264.93 C 478.31 265.08 478.49 265.39 478.58 265.55 C 478.49 265.39 478.31 265.08 478.22 264.93 Z"
          />
          <path
            opacity="1.00"
            d=" M 479.56 267.25 C 479.60 267.32 479.68 267.46 479.72 267.53 C 479.68 267.46 479.60 267.32 479.56 267.25 Z"
          />
          <path
            opacity="1.00"
            d=" M 480.70 269.21 C 480.74 269.28 480.82 269.41 480.86 269.48 C 480.82 269.41 480.74 269.28 480.70 269.21 Z"
          />
          <path
            opacity="1.00"
            d=" M 481.84 271.18 C 481.94 271.35 482.13 271.68 482.23 271.85 C 482.13 271.68 481.94 271.35 481.84 271.18 Z"
          />
          <path
            opacity="1.00"
            d=" M 482.23 271.85 C 482.32 272.02 482.51 272.35 482.60 272.51 C 482.51 272.35 482.32 272.02 482.23 271.85 Z"
          />
          <path
            opacity="1.00"
            d=" M 483.61 274.29 C 483.75 274.64 484.03 275.32 484.17 275.66 C 484.03 275.32 483.75 274.64 483.61 274.29 Z"
          />
          <path
            opacity="1.00"
            d=" M 484.45 276.21 C 484.54 276.36 484.71 276.65 484.80 276.79 L 484.58 276.50 L 484.45 276.21 Z"
          />
          <path
            opacity="1.00"
            d=" M 485.39 277.68 C 485.60 278.01 486.01 278.67 486.22 279.00 C 486.01 278.67 485.60 278.01 485.39 277.68 Z"
          />
          <path
            opacity="1.00"
            d=" M 486.22 279.00 C 486.34 279.20 486.60 279.60 486.72 279.80 C 486.60 279.60 486.34 279.20 486.22 279.00 Z"
          />
          <path
            opacity="1.00"
            d=" M 487.38 280.85 C 487.58 281.30 487.98 282.21 488.18 282.66 C 487.98 282.21 487.58 281.30 487.38 280.85 Z"
          />
          <path
            opacity="1.00"
            d=" M 488.48 283.20 C 488.53 283.29 488.63 283.46 488.68 283.54 L 488.59 283.41 L 488.48 283.20 Z"
          />
          <path
            opacity="1.00"
            d=" M 490.43 286.15 C 490.54 286.33 490.76 286.69 490.88 286.87 C 490.76 286.69 490.54 286.33 490.43 286.15 Z"
          />
          <path
            opacity="1.00"
            d=" M 491.48 287.87 C 491.57 288.03 491.75 288.34 491.84 288.49 C 491.75 288.34 491.57 288.03 491.48 287.87 Z"
          />
          <path
            opacity="1.00"
            d=" M 492.85 290.26 C 492.94 290.42 493.12 290.74 493.21 290.90 C 493.12 290.74 492.94 290.42 492.85 290.26 Z"
          />
          <path
            opacity="1.00"
            d=" M 493.21 290.90 C 493.30 291.06 493.48 291.37 493.57 291.53 C 493.48 291.37 493.30 291.06 493.21 290.90 Z"
          />
          <path
            opacity="1.00"
            d=" M 494.57 293.24 C 494.61 293.32 494.70 293.47 494.75 293.54 C 494.70 293.47 494.61 293.32 494.57 293.24 Z"
          />
          <path
            opacity="1.00"
            d=" M 495.66 295.14 C 495.72 295.24 495.84 295.45 495.90 295.55 C 495.84 295.45 495.72 295.24 495.66 295.14 Z"
          />
          <path
            opacity="1.00"
            d=" M 496.82 297.16 C 496.93 297.34 497.14 297.71 497.25 297.89 C 497.14 297.71 496.93 297.34 496.82 297.16 Z"
          />
          <path
            opacity="1.00"
            d=" M 497.25 297.89 C 497.34 298.05 497.53 298.37 497.62 298.53 C 497.53 298.37 497.34 298.05 497.25 297.89 Z"
          />
          <path
            opacity="1.00"
            d=" M 436.06 299.75 C 461.15 306.68 485.77 315.21 510.79 322.40 L 511.01 323.22 C 482.92 323.86 454.79 323.33 426.69 323.48 C 428.98 319.77 434.54 319.04 435.47 314.39 C 436.68 309.61 435.72 304.62 436.06 299.75 Z"
          />
          <path
            opacity="1.00"
            d=" M 499.73 302.29 C 499.83 302.50 500.03 302.92 500.12 303.13 C 500.03 302.92 499.83 302.50 499.73 302.29 Z"
          />
          <path
            opacity="1.00"
            d=" M 500.58 304.17 C 500.70 304.37 500.94 304.78 501.05 304.98 C 500.94 304.78 500.70 304.37 500.58 304.17 Z"
          />
          <path
            opacity="1.00"
            d=" M 501.05 304.98 C 501.20 305.18 501.49 305.56 501.64 305.75 C 501.49 305.56 501.20 305.18 501.05 304.98 Z"
          />
          <path
            opacity="1.00"
            d=" M 502.33 306.73 C 502.45 306.92 502.69 307.30 502.82 307.50 C 502.69 307.30 502.45 306.92 502.33 306.73 Z"
          />
          <path
            opacity="1.00"
            d=" M 503.83 309.25 C 503.92 309.41 504.10 309.73 504.19 309.89 C 504.10 309.73 503.92 309.41 503.83 309.25 Z"
          />
          <path
            opacity="1.00"
            d=" M 504.19 309.89 C 504.28 310.05 504.46 310.36 504.56 310.52 C 504.46 310.36 504.28 310.05 504.19 309.89 Z"
          />
          <path
            opacity="1.00"
            d=" M 505.56 312.24 C 505.60 312.32 505.68 312.46 505.72 312.53 C 505.68 312.46 505.60 312.32 505.56 312.24 Z"
          />
          <path
            opacity="1.00"
            d=" M 506.67 314.19 C 506.71 314.26 506.79 314.39 506.83 314.46 C 506.79 314.39 506.71 314.26 506.67 314.19 Z"
          />
          <path
            opacity="1.00"
            d=" M 507.80 316.15 C 507.90 316.32 508.10 316.66 508.20 316.84 C 508.10 316.66 507.90 316.32 507.80 316.15 Z"
          />
          <path
            opacity="1.00"
            d=" M 508.20 316.84 C 508.30 317.01 508.50 317.35 508.59 317.52 C 508.50 317.35 508.30 317.01 508.20 316.84 Z"
          />
          <path
            opacity="1.00"
            d=" M 509.59 319.24 C 509.63 319.31 509.70 319.45 509.74 319.52 C 509.70 319.45 509.63 319.31 509.59 319.24 Z"
          />
          <path
            opacity="1.00"
            d=" M 510.80 321.50 C 510.93 321.73 511.18 322.19 511.31 322.42 L 510.79 322.40 L 510.80 321.50 Z"
          />
        </g>
        <g>
          <path
            opacity="1.00"
            d=" M 148.09 376.07 C 158.40 358.49 168.20 340.58 178.85 323.21 C 230.48 323.40 282.12 322.92 333.74 323.40 L 334.40 323.45 C 308.29 324.29 282.11 323.23 256.00 323.89 C 251.02 327.10 247.70 332.30 242.93 335.80 C 238.50 339.03 235.24 343.53 231.01 346.98 C 225.08 351.35 220.67 357.41 214.65 361.69 C 207.69 369.06 199.66 375.27 192.64 382.60 C 187.38 386.64 182.98 391.63 178.08 396.08 C 172.69 399.99 168.56 405.29 163.52 409.61 C 163.39 409.72 163.14 409.94 163.01 410.06 C 162.74 410.27 162.21 410.71 161.94 410.92 C 161.81 411.03 161.57 411.23 161.44 411.34 C 157.47 414.41 154.43 418.46 150.53 421.61 C 150.40 421.72 150.15 421.93 150.03 422.03 C 149.90 422.14 149.65 422.35 149.52 422.45 C 143.83 427.12 139.27 433.03 133.30 437.38 C 127.29 443.34 120.51 448.46 114.80 454.74 C 106.36 461.68 99.06 469.87 90.36 476.52 C 92.52 471.81 95.38 467.49 97.89 462.98 C 114.63 434.01 131.35 405.04 148.09 376.07 Z"
          />
          <path
            opacity="1.00"
            d=" M 89.92 477.16 C 90.03 477.00 90.25 476.68 90.36 476.52 L 90.33 477.17 L 89.92 477.16 Z"
          />
        </g>
        <g>
          <path
            opacity="1.00"
            d=" M 334.40 323.45 C 365.16 323.58 395.92 323.49 426.69 323.48 C 454.79 323.33 482.92 323.86 511.01 323.22 L 511.60 323.18 L 512.00 323.29 L 512.00 323.37 C 482.34 374.64 452.77 425.97 423.11 477.25 C 312.18 477.22 201.25 477.35 90.33 477.17 L 90.36 476.52 C 99.06 469.87 106.36 461.68 114.80 454.74 C 120.51 448.46 127.29 443.34 133.30 437.38 C 139.27 433.03 143.83 427.12 149.52 422.45 C 149.65 422.35 149.90 422.14 150.03 422.03 C 150.15 421.93 150.40 421.72 150.53 421.61 C 154.43 418.46 157.47 414.41 161.44 411.34 C 161.57 411.23 161.81 411.03 161.94 410.92 C 162.21 410.71 162.74 410.27 163.01 410.06 C 163.14 409.94 163.39 409.72 163.52 409.61 C 168.56 405.29 172.69 399.99 178.08 396.08 C 182.98 391.63 187.38 386.64 192.64 382.60 C 199.66 375.27 207.69 369.06 214.65 361.69 C 220.67 357.41 225.08 351.35 231.01 346.98 C 235.24 343.53 238.50 339.03 242.93 335.80 C 247.70 332.30 251.02 327.10 256.00 323.89 C 282.11 323.23 308.29 324.29 334.40 323.45 Z"
          />
        </g>
        <g>
          <path
            opacity="1.00"
            d=" M 163.01 410.06 C 163.14 409.94 163.39 409.72 163.52 409.61 C 163.39 409.72 163.14 409.94 163.01 410.06 Z"
          />
          <path
            opacity="1.00"
            d=" M 161.94 410.92 C 162.21 410.71 162.74 410.27 163.01 410.06 C 162.74 410.27 162.21 410.71 161.94 410.92 Z"
          />
          <path
            opacity="1.00"
            d=" M 161.44 411.34 C 161.57 411.23 161.81 411.03 161.94 410.92 C 161.81 411.03 161.57 411.23 161.44 411.34 Z"
          />
          <path
            opacity="1.00"
            d=" M 150.03 422.03 C 150.15 421.93 150.40 421.72 150.53 421.61 C 150.40 421.72 150.15 421.93 150.03 422.03 Z"
          />
          <path
            opacity="1.00"
            d=" M 149.52 422.45 C 149.65 422.35 149.90 422.14 150.03 422.03 C 149.90 422.14 149.65 422.35 149.52 422.45 Z"
          />
        </g>
      </g>
    </Icon>
  );
};

export default gdriveIcon;